import {IApiEndpoints} from "../typings/apiEndpoints";
import {
    IApiUserShortProfile, IApiUserFullProfile, IApiUserBasicProfile, IApiUser,
    IApiPremiumAccountMap
} from "../typings/apiResponse";
import * as angular from "angular";

export class UserResource {
    public static $inject = ["$http", "ApiEndpoints"];
    constructor(private $http: angular.IHttpService, private ApiEndpoints: IApiEndpoints) {}

    public getShortDescription(userId: string, format?: string): angular.IPromise<string> {
        return this.$http.get(this.ApiEndpoints.user + '/' + userId + '/shortdescription', {
            params: {
                format: format
            }
        }).then(
            function (response: angular.IHttpPromiseCallbackArg<string>) {
                return response.data;
            }
        );
    }

    public getDescription(userId: string, format?: string): angular.IPromise<string> {
        return this.$http.get(this.ApiEndpoints.user + '/' + userId + '/description', {
            params: {
                format: format
            }
        }).then(
            function (response: angular.IHttpPromiseCallbackArg<string>) {
                return response.data;
            }
        );
    }

    public getShortProfileForLoggedInUser(): angular.IPromise<IApiUserShortProfile> {
        return this.$http.get(this.ApiEndpoints.userProfileShort).then(
            (response: angular.IHttpPromiseCallbackArg<IApiUserShortProfile>) => {
                return response.data;
            }
        );
    }

    public getFullProfileForLoggedInUser(): angular.IPromise<IApiUserFullProfile> {
        return this.$http.get(this.ApiEndpoints.userProfileFull).then(
            (response: angular.IHttpPromiseCallbackArg<IApiUserFullProfile>) => {
                return response.data;
            }
        );
    }

    public getBasicProfileForLoggedInUser(): angular.IPromise<IApiUserBasicProfile> {
        return this.$http.get(this.ApiEndpoints.userProfileBasic).then(
            (response: angular.IHttpPromiseCallbackArg<IApiUserBasicProfile>) => {
                return response.data;
            }
        );
    }

    public getUsers(userIds: string[], fields?: string[]): angular.IPromise<IApiUser[]> {
        const fieldsParam = fields ? '&fields=' + fields.join(',') : '';
        return this.$http.get(this.ApiEndpoints.user + '?ids=' + userIds.join(',') + fieldsParam).then(
            (response: angular.IHttpPromiseCallbackArg<IApiUser[]>) => {
                return response.data;
            }
        );
    }

    public getPremiumDaysForLoggedInUser(): angular.IPromise<IApiPremiumAccountMap> {
        return this.$http.get(this.ApiEndpoints.userPremium).then(
            (response: angular.IHttpPromiseCallbackArg<IApiPremiumAccountMap>) => {
                return response.data;
            }
        );
    }
}
